import { Badge } from '@/components/ui/badge';
import { useLanguage } from '@/contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-primary text-primary-foreground py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="bg-primary-foreground text-primary px-3 py-1 font-bold text-xl mr-4">
                IAC
              </div>
              <span className="text-lg font-semibold">
                IAC GROUP (SLOVAKIA) s.r.o.
              </span>
            </div>
            <p className="text-primary-foreground/80 mb-4 leading-relaxed">
              {t('footer.description')}
            </p>
            <div className="flex flex-wrap gap-2">
              <Badge variant="secondary">ISO 9001</Badge>
              <Badge variant="secondary">ISO 14001</Badge>
              <Badge variant="secondary">IATF 16949</Badge>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2 text-primary-foreground/80">
              <li><a href="#home" className="hover:text-primary-foreground transition-colors">{t('nav.home')}</a></li>
              <li><a href="#about" className="hover:text-primary-foreground transition-colors">{t('nav.about')}</a></li>
              <li><a href="#services" className="hover:text-primary-foreground transition-colors">{t('nav.services')}</a></li>
              <li><a href="#quality" className="hover:text-primary-foreground transition-colors">{t('nav.quality')}</a></li>
              <li><a href="#contact" className="hover:text-primary-foreground transition-colors">{t('nav.contact')}</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.contact')}</h3>
            <div className="space-y-2 text-primary-foreground/80">
              <p>IAC Group (Slovakia) s.r.o.</p>
              <p>Slovakia</p>
              <p>info@iacslovakia.sk</p>
              <p>+421 XXX XXX XXX</p>
            </div>
          </div>
        </div>

        <hr className="border-primary-foreground/20 my-8" />

        {/* Admin Button in Center */}
        <div className="text-center mb-6">
          <a
            href="/admin"
            className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
          >
            {t('footer.admin')}
          </a>
        </div>

        <hr className="border-primary-foreground/20 my-8" />

        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-primary-foreground/60 text-sm">
            {t('footer.copyright')}
          </p>
          <div className="flex gap-4 mt-4 md:mt-0">
            <a href="#" className="text-primary-foreground/60 hover:text-primary-foreground text-sm transition-colors">
              {t('footer.privacy')}
            </a>
            <a href="#" className="text-primary-foreground/60 hover:text-primary-foreground text-sm transition-colors">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;